import { createFileRoute,useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { RouteError } from '@/components/route-error'
import { RoutePending } from '@/components/route-pending'
import { PosOrderProvider } from '@/features/pos/cart/pos-order-context'
import { PosTerminal } from '@/features/pos/v2/components/pos-terminal'
import { requireAuth } from '@/lib/auth'
import { FullBleedLayoutProvider } from '@/lib/full-bleed-layout-context'

const searchSchema = z.object({
  returnOrderId: z.string().optional(),
  resumeOrderId: z.string().optional(),
})

export const Route = createFileRoute('/_dashboard/terminal')({
  beforeLoad: requireAuth(),
  validateSearch: searchSchema,
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: TerminalPage,
})

function TerminalPage() {
  const { returnOrderId, resumeOrderId } = Route.useSearch()
  const navigate = useNavigate()

  function clearReturnParam() {
    void navigate({ to: '.', search: {}, replace: true })
  }

  return (
    <FullBleedLayoutProvider>
      <PosOrderProvider>
        <PosTerminal
          initialReturnOrderId={returnOrderId}
          initialResumeOrderId={resumeOrderId}
          onReturnParamConsumed={clearReturnParam}
        />
      </PosOrderProvider>
    </FullBleedLayoutProvider>
  )
}
